
import { ApiConfig } from '../../Config';
import axios from 'axios';

var VerifyOtpPasswordCtrl = function (fn, er, state, token, ids) {

    var config = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'MT_SESSION_ID': ids
        }
    };
    var data = {
        newPassword: state.newPassword,
        oldPassword: state.oldPassword,
        otp: state.otp
    };


    axios
        .post(ApiConfig.url.OTP_PASSWORD, data, config)
        .then(function (result) {
            fn(result.data, result.status)
        })
        .catch(function (error) {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500,
               error !== undefined && error.response !== undefined && error.response.data !== undefined && error.response.data.details !== undefined ? error.response.data.details[0] : '5709')
        });


}

export { VerifyOtpPasswordCtrl };